import React, { useEffect, useState } from 'react';
import { goToLogin } from 'helpers/noSession';
import LoaderCP from 'components/loader';
import { useSelector } from 'react-redux';
import SocketConnection from 'socket';
import ItemCanOffer from './ItemCanOffer';
import ItemClose from './ItemClose';
import ItemSuccess from './ItemSuccess';
import ItemExtended from './ItemExtended';
import ItemCloseNoWinner from './ItemCloseNoWinner';

const SideBarOffer = () => {
  const { statusOffer } = useSelector((state) => state.offer);
  const { error, type } = useSelector((state) => state.offer.offer);
  const { status, id } = useSelector((state) => state.detail.detail);

  const { extendedAuction, statusExtendedAuction } = useSelector((state) => state.offersSocket);
  const { auctionId, extended } = extendedAuction;

  const [extendedAuctionSocket, setExtendedAuctionSocket] = useState(false);

  const validateSocketDataAuction = () => {
    if (auctionId.toString() === id.toString()) {
      if (extended && statusExtendedAuction) {
        setExtendedAuctionSocket(true);
      }
    }
    return extendedAuctionSocket;
  };

  useEffect(() => {
    if (auctionId !== undefined) {
      validateSocketDataAuction();
    }
  }, []);

  return (
    <>
      <SocketConnection />
      {statusOffer === 'loading' && <LoaderCP />}
      {statusOffer === 'success' && error === 'Forbidden' && goToLogin()}

      {status === 'PUBLISHED' && statusOffer === '' && extendedAuctionSocket === false && <ItemCanOffer />}
      {status === 'PUBLISHED' && statusOffer === 'success' && error && type === 'offerOvered' && extendedAuctionSocket === false && <ItemCanOffer />}
      {status === 'PUBLISHED' && statusOffer === 'success' && error === false && extendedAuctionSocket === false && <ItemSuccess />}
      {status === 'PUBLISHED' && extendedAuctionSocket && <ItemExtended />}

      {status === 'CLOSED' && <ItemCloseNoWinner />}
      {status === 'CLOSED_WITH_WINNERS' && <ItemClose />}
    </>
  );
};

export default SideBarOffer;
